import { render, staticRenderFns } from "./PolygonControls.vue?vue&type=template&id=61498410&scoped=true"
import script from "./PolygonControls.vue?vue&type=script&lang=js"
export * from "./PolygonControls.vue?vue&type=script&lang=js"
import style0 from "./PolygonControls.vue?vue&type=style&index=0&id=61498410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61498410",
  null
  
)

export default component.exports